import accountsAPI from "@/api/accounts";

const getDefaultState = () => ({
  accountSearch: [],
  isAccountSearchLoading: false,
  isAccountSearchError: false,
  isAccountSearchErrorResponse: null,
});

const state = getDefaultState();

const mutations = {
  FETCH_ACCOUNT_SEARCH_BEGIN(state) {
    state.isAccountSearchLoading = true;
    state.isAccountSearchError = false;
    state.isAccountSearchErrorResponse = null;
  },
  FETCH_ACCOUNT_SEARCH_SUCCESS(state, payload) {
    state.accountSearch = payload;
    state.isAccountSearchLoading = false;
  },
  FETCH_ACCOUNT_SEARCH_ERROR(state, error) {
    state.isAccountSearchLoading = false;
    state.isAccountSearchError = true;
    state.isAccountSearchErrorResponse = error;
  },
  
  RESET_ACCOUNT_SEARCH(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchAccountSearch({ commit, dispatch }, query) {
    commit("FETCH_ACCOUNT_SEARCH_BEGIN");

    try {
      let res = await accountsAPI.searchAccounts(query);
      commit("FETCH_ACCOUNT_SEARCH_SUCCESS", res);
    } catch(error) {
      commit("FETCH_ACCOUNT_SEARCH_ERROR", error);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },
};

const getters = {
  getAccountSearch: state => state.accountSearch,
  getIsAccountSearchLoading: state => state.isAccountSearchLoading,
  getIsAccountSearchError: state => state.isAccountSearchError,
  getIsAccountSearchErrorResponse: state => state.isAccountSearchErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
